import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  getStoredUserDetail,
  hasAuthToken,
  PENDING_SUBSCRIPTION_ONBOARDING_KEY,
} from '../../../Utils/authStorage';
import { SETTINGS_SUBSCRIPTION_PATH } from '../../../Utils/subscriptionAccess';
import SubscriptionCheckoutFlow from '../../Shared/SubscriptionCheckoutFlow';
import '../../../Auth.css';
import AuthLeftBranding from './AuthLeftBranding';

export default function SignupPayment() {
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.state?.role;
  const fromSettings = Boolean(location.state?.fromSettings);
  const selectedPlan = location.state?.selectedPlan;
  const planCategory = location.state?.planCategory;
  const initialClientSecret = location.state?.clientSecret || '';
  const initialAmount = location.state?.amount;

  const [allowRender, setAllowRender] = useState(() => Boolean(initialClientSecret || selectedPlan));

  useEffect(() => {
    if (initialClientSecret) return;
    if (!hasAuthToken()) {
      toast.error('Please sign in to continue.');
      navigate('/login', { replace: true });
    }
  }, [initialClientSecret, navigate]);

  useEffect(() => {
    if (initialClientSecret) return;
    if (!hasAuthToken()) return;
    if (!selectedPlan) {
      toast.error('Please choose a plan first.');
      if (fromSettings) {
        navigate(SETTINGS_SUBSCRIPTION_PATH, { replace: true });
      } else {
        navigate('/register/plans', { replace: true, state: role ? { role } : undefined });
      }
    }
  }, [selectedPlan, initialClientSecret, navigate, role, fromSettings]);

  const goToDashboardAfterCheckout = () => {
    localStorage.removeItem(PENDING_SUBSCRIPTION_ONBOARDING_KEY);
    if (fromSettings) {
      toast.success('Subscription active! Welcome to Fam Connect.');
      navigate('/dashboard');
    } else {
      toast.success('Welcome to Fam Connect!');
      navigate('/user/dashboard');
    }
  };

  if (!hasAuthToken()) {
    return null;
  }

  if (!allowRender && !initialClientSecret) {
    return null;
  }

  return (
    <div className="login-main">
      <div className="left-div">
        <AuthLeftBranding />
      </div>

      <div className="login-container signup-payment-panel">
        <SubscriptionCheckoutFlow
          selectedPlan={selectedPlan}
          planCategory={planCategory}
          initialClientSecret={initialClientSecret}
          initialAmount={initialAmount}
          onPaymentSuccess={goToDashboardAfterCheckout}
          headerSlot={
            <div className="signup-payment-back">
              <Link
                to={fromSettings ? SETTINGS_SUBSCRIPTION_PATH : '/register/plans'}
                state={fromSettings ? undefined : { role, selectedPlan, planCategory }}
                className="signup-payment-back-link"
              >
                ← Back to {fromSettings ? 'subscription plans' : 'plans'}
              </Link>
            </div>
          }
        />
      </div>
    </div>
  );
}
